import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { consumeListsRefreshFlag } from "../utils/markListsRefresh";

const NavigationRefreshContext = createContext(0);

export function NavigationRefreshProvider({ children }) {
  const location = useLocation();
  const [tick, setTick] = useState(0);
  const prevSig = useRef("");

  useEffect(() => {
    const sig = `${location.pathname}${location.search}|${location.state?.navRefresh ?? ""}`;
    const forced = consumeListsRefreshFlag();
    if (prevSig.current !== sig || forced) {
      prevSig.current = sig;
      setTick((t) => t + 1);
    }
  }, [location.pathname, location.search, location.state?.navRefresh]);

  return (
    <NavigationRefreshContext.Provider value={tick}>
      {children}
    </NavigationRefreshContext.Provider>
  );
}

export function useNavigationRefreshTick() {
  return useContext(NavigationRefreshContext);
}
